import { render, staticRenderFns } from "./TamanioList.vue?vue&type=template&id=6024faab&scoped=true&"
import script from "./TamanioList.vue?vue&type=script&lang=js&"
export * from "./TamanioList.vue?vue&type=script&lang=js&"
import style0 from "./TamanioList.vue?vue&type=style&index=0&id=6024faab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024faab",
  null
  
)

export default component.exports